import { render, staticRenderFns } from "./ProducerChangeName.vue?vue&type=template&id=a966ddee"
import script from "./ProducerChangeName.vue?vue&type=script&lang=js"
export * from "./ProducerChangeName.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports